import { Box } from "@mui/material";
import { type FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { type FlatSwitchOption, SystemFlatSwitch } from "../../../../../components/UIToolkit/Clickable/SystemFlatSwitch";
import { HrisJobAlignment } from "./HrisJobAlignment/HrisJobAlignment";
import { RolesMappingGrid } from "./RolesMappingGrid";

enum RolesView {
	RawTableConfig = "rawTableConfig",
	PrettyMapping = "prettyMapping",
}

/**
 * Wrapper around the Roles & Jobs tab that adds a Raw Table / Pretty Mapping toggle.
 *
 * Defaults to Pretty Mapping (the new view). The orphan banner in Raw Table view links here
 * via the `onSwitchToPretty` prop on `RolesMappingGrid`.
 */
export const RolesTabContent: FC = () => {
	const { t } = useTranslation();
	const [view, setView] = useState<RolesView>(RolesView.PrettyMapping);

	const options: FlatSwitchOption<RolesView>[] = [
		{ label: t("hris.mapping.view.pretty"), value: RolesView.PrettyMapping, "data-testid": "hris-mapping-roles-view-pretty" },
		{ label: t("hris.mapping.view.rawTable"), value: RolesView.RawTableConfig, "data-testid": "hris-mapping-roles-view-raw" },
	];

	return (
		<Box sx={{ display: "flex", flexDirection: "column", gap: 1, height: "100%" }} data-testid="hris-mapping-roles-tab">
			<Box>
				<SystemFlatSwitch<RolesView>
					options={options}
					activeIndexOrValue={view}
					onSwitch={(option) => setView(option.value)}
					rootMaxWidth={360}
					data-testid="hris-mapping-roles-view-switch"
				/>
			</Box>
			<Box sx={{ flex: 1, minHeight: 0 }}>
				{view === RolesView.PrettyMapping ? <HrisJobAlignment /> : <RolesMappingGrid onSwitchToPretty={() => setView(RolesView.PrettyMapping)} />}
			</Box>
		</Box>
	);
};
